import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  class: "dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
], -1)
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Titre "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Menu Parent "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Position "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Lien "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase f w-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
    }, "ACTIONS")
  ])
], -1)
const _hoisted_12 = { class: "dropdown" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_14 = { class: "dropdown-menu" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_18 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
          to: "/ajouter-menu"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Ajouter ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", {
          class: "search-box position-relative me-15",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher un menu"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _hoisted_6
        ], 32),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("table", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: menu.id
              }, [
                _createElementVNode("td", null, _toDisplayString(menu.titre), 1),
                _createElementVNode("td", null, _toDisplayString(menu.menu ? menu.menu.titre : '-'), 1),
                _createElementVNode("td", null, _toDisplayString(menu.position), 1),
                _createElementVNode("td", null, _toDisplayString(menu.lien), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("ul", _hoisted_14, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'EditMenuPage', params: { id: menu.id } },
                          class: "dropdown-item d-flex align-items-center"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_15,
                            _createTextVNode("Modifier ")
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item d-flex align-items-center",
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.deleteMenu(menu.id))
                        }, [
                          _hoisted_17,
                          _createTextVNode("Supprimer ")
                        ], 8, _hoisted_16)
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}